<mat-card>
  <mat-card-content class="p-0">
    <app-datatable
      [configurationInput]="datatableConfigurations"
      [rowData]="store.data$()"
      [columns]="datatableColumns"
      [total]="this.store.dataTotal$()"
      [customColumnDef]="[{ name: 'name', template: nameCell, isSortable: true }]"
      (deleteClick)="initializeDelete()"
      (editClick)="initializeEdit()"
      (addClick)="initializeAdd()"
      (dataRefreshRequest)="datatableParams$.next($event)"
      (selectedItemsChange)="selectedDatatableItems.set($event)"
    />
  </mat-card-content>
</mat-card>

<ng-template #nameCell let-row="row">
  <span style="display: inline-flex; align-items: center; gap: 10px">
    <app-status-category-badge
      [statusCategory]="row.statusCategory"
      [label]="row.isDefault ? ('system.label.' + row.name | translate) : row.name"
    ></app-status-category-badge>
    <mat-chip *ngIf="row.isDefault">{{ 'system.label.default' | translate | uppercase }}</mat-chip>
  </span>
</ng-template>

<ng-template #addEditFormDialog>
  <h1 mat-dialog-title>
    {{ addEditModalTitle() }}
  </h1>
  <form [formGroup]="addEditForm" (ngSubmit)="onFormDialogSubmit()" #form="ngForm">
    <div mat-dialog-content>
      <div class="row">
        <div class="col-12 mb-3">
          <span class="dialog-section"
            ><mat-icon>description</mat-icon> {{ 'system.dialogSection.generalInformation' | translate }}</span
          >
        </div>
        <mat-form-field appearance="outline">
          <mat-label>{{ 'field.name' | translate }}</mat-label>
          <input matInput formControlName="name" />
          <mat-error [control]="addEditForm.controls.name"></mat-error>
        </mat-form-field>
        <mat-dropdown
          class="col-12"
          [options]="statusCategoryOptions"
          [configurationInput]="{
            singleSelection: true,
            enableSearchFilter: false,
            hasMatError: true,
            text: 'field.statusCategory' | translate,
            repositionDropdownList: true,
          }"
          [formControl]="addEditForm.controls.statusCategory"
          [isFormSubmitted]="form.submitted"
        ></mat-dropdown>
      </div>
    </div>
    <mat-dialog-actions align="end">
      <button matButton="tonal" mat-dialog-close>{{ 'button.cancel' | translate }}</button>
      <button mat-flat-button type="submit">
        {{ addEditSubmitButtonText() }}
      </button>
    </mat-dialog-actions>
  </form>
</ng-template>
